import {PureComponent} from 'react'
import {Card} from 'reactstrap'

import './FrontCard.scss'

export default class FrontCard extends PureComponent {
  render() {
    return <Card className={`search-card-front h-100 text-center ${this.props.className}`}>
      {this.props.children}
      {this.props.score ? (<div className="score">Score: {Math.round(this.props.score)}</div>) : ''}
    </Card>
  }
}